import React from "react";
import {Container} from "react-bootstrap";
export default function Loading() {
    return (
        <Container>
            <div className="spinner-container text-center">
                <div className="spinner">
                    <div className="spinner-head"></div>
                </div>
            </div>
        </Container>
    );
}
export function InlineLoading() {
    return (
        <div className="loader-wrapper">
            <div className="loader"></div>
        </div>
    )
}